/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as Url from "url-parse"
import { isEmpty } from "lodash"

class Utils {
    /**
     * sluggify Transforme une chaine de caractaire "testString" en "test-string"
     * et enlève tous les caractaires non pris en charges
     * @param s chaine à transformer
     */
    public static sluggify(s: string): string {
        let result = s
        result = result.replace(
            /[A-Z]/g,
            (letter) => `-${letter.toLowerCase()}`
        )
        result = result.replace(/^\s+|\s+$/g, "") // trim
        result = result.toLowerCase()

        const from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
        const to = "aaaaeeeeiiiioooouuuunc------"
        for (let i = 0, l = from.length; i < l; i += 1) {
            result = result.replace(
                new RegExp(from.charAt(i), "g"),
                to.charAt(i)
            )
        }

        return result
            .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
            .replace(/\s+/g, "-") // collapse whitespace and replace by -
            .replace(/-+/g, "-") // collapse dashes
    }

    /**
     * toClassName Transforme une chaine de caractaire "test-string" en "testString"
     * @param s chaine à transformer
     */
    public static toClassName(s: string): string {
        return s.replace(
            /-[a-z0-9]/g,
            (letter: string) => `${letter.replaceAll("-", "").toUpperCase()}`
        )
    }

    /**
     * getUrlHash parse l'URL et renvoie le hash qu'il contient
     */
    public static getUrlHash(): string {
        const url = Url.default(window.location.href, true)
        // suppression du #
        return url.hash.replace("#", "")
    }

    /**
     * setUrlHash set le hash dans l'URL
     * @param object queryparams object ex. {param1: xxx, params2: yyy}
     */
    public static setUrlHash(pageName: string, object?: unknown): void {
        window.location.hash = `${this.sluggify(pageName)}${
            object && !isEmpty(object)
                ? `?${Utils.queryParamsObjectToString(object)}`
                : ""
        }`
    }

    public static getOrigin(url: string) {
        const tmp = document.createElement("a")
        tmp.href = url
        return tmp.origin
    }

    /**
     * getUrlEncode
     * @param redirString string de redirection
     */
    public static getUrlEncode(redirString: string) {
        // on récupère
        return encodeURIComponent(redirString)
    }

    /**
     * queryParamsObjectToString prend on object de params {param1: xxx, params2: yyy}
     * et le transforme en queryString param1=xxx&params2=yyy
     */
    public static queryParamsObjectToString(object: any): string {
        let result = ""
        if (object) {
            const objectKeys = Object.keys(object)
            if (objectKeys.length) {
                result = ""
                objectKeys.forEach((key, index) => {
                    if (object[key] && object[key] !== "") {
                        result += `${key}=${object[key]}&`
                    }
                })
                // suppr du dernier &
                if (result[result.length - 1] === "&") {
                    result = result.substring(0, result.length - 1)
                }
            }
        }

        return result
    }
}

export default Utils
